var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1023.81 359.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#09f;}.cls-2{fill:none;}.cls-3,.cls-4,.cls-5{isolation:isolate;}.cls-4,.cls-5{font-size:49.22px;}.cls-4{font-family:Lato-Light, Lato;font-weight:300;}.cls-5{font-family:Lato-Regular, Lato;}.cls-6{letter-spacing:-0.02em;}.cls-7{font-size:18px;letter-spacing:0em;}.cls-8{letter-spacing:-0.01em;}.cls-9{letter-spacing:0em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.15,204.68a38.21,38.21,0,0,1-5.94,4.61A39.33,39.33,0,0,1,129,214L124.57,215l-6.33,1.23a63.18,63.18,0,0,0-7.65,2.37,43.9,43.9,0,0,0-8.84,4.59,22.81,22.81,0,0,0-9.69,15.41,18.51,18.51,0,0,0,.59,6.43,6.28,6.28,0,0,0,2.84,1.46s8.28.52,13.48-2.4c0,0,7.44-4.06,11.56-8.18,0,0,7.86-7.68,11.36-11.43,0,0-4.15,7.95-8.66,12.54,0,0-5.89,6.67-11.8,8.92a61.57,61.57,0,0,1-9.22,3.22s-13.66,4.36-16,5.47c0,0-5.54,2.88-6.68,5.49l10.07.95s1.36-3.62,3.6-4.85a8.91,8.91,0,0,1,5.06-1.4l8.39.28s7.76-.3,11.75-2.05c0,0,9.18-3.64,14.84-10.59,0,0,4.21-5,7.86-16.77C141.12,225.71,145.17,208.79,144.15,204.68Z",
    transform: "translate(-45.1 -45.24)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111,287.75a78.2,78.2,0,0,1-38.7-12.11Q52.23,263.06,45.1,242l18.82-7.46q4.86,14.26,19.73,23A61.86,61.86,0,0,0,111.88,266q23.22,1,38.85-12.77,14-12.25,14.72-28.84,1.22-31.15-52.21-47.57Q74.69,165.08,58.15,144a53.62,53.62,0,0,1-11.83-36.13q1.36-34,26.4-50.73Q92.61,43.9,120.83,45.39q34,1.66,54.33,25.53L160.44,85.84q-14.72-17.4-40.52-18.73-22.15-1-36.72,8.62Q67.26,86.5,66.35,108.88q-1.21,30.51,52.21,46.91,38.53,11.78,55.08,33a54.53,54.53,0,0,1,11.84,36.47q-1.22,26.69-22.16,45.09-20,17.57-48.41,17.57C113.6,287.91,112.28,287.85,111,287.75Z",
    transform: "translate(-45.1 -45.24)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.37,47.55V69.43H275.31V285.59h-20V69.43H198.06V47.55Z",
    transform: "translate(-45.1 -45.24)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M502.48,285.59H480L428.87,178h-52.2V285.42h-20V47.55h78.3q24.74,0,42.19,19.23,17.46,19.06,17.45,46.08A67.6,67.6,0,0,1,482,153q-12.3,17.24-31.57,22.87ZM434.94,156.13q16.4,0,28.08-12.6,11.53-12.76,11.53-30.67T463,82.19q-11.68-12.76-28.08-12.76H376.67v86.7Z",
    transform: "translate(-45.1 -45.24)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M673.8,47.55v238H653.92V226.08h-86.5L533,285.59H509.29l137.8-238ZM580,204.2h73.91V76.72Z",
    transform: "translate(-45.1 -45.24)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M830.25,47.55V69.43H773.19V285.59h-20V69.43H695.94V47.55Z",
    transform: "translate(-45.1 -45.24)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M859.84,46.39H880v239.2H859.84Z",
    transform: "translate(-45.1 -45.24)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M975.17,287.75a78.26,78.26,0,0,1-38.7-12.11q-20-12.58-27.16-33.65l18.82-7.46q4.85,14.26,19.72,23A61.86,61.86,0,0,0,976.08,266q23.22,1,38.85-12.77,14-12.25,14.72-28.84,1.21-31.15-52.2-47.57Q938.9,165.08,922.36,144a53.58,53.58,0,0,1-11.84-36.13q1.37-34,26.41-50.73Q956.81,43.9,985,45.39q34,1.66,54.33,25.53l-14.72,14.92q-14.72-17.4-40.52-18.73-22.15-1-36.72,8.62-15.93,10.77-16.85,33.15-1.21,30.51,52.21,46.91,38.55,11.78,55.09,33a54.52,54.52,0,0,1,11.83,36.47q-1.22,26.69-22.15,45.09-20,17.57-48.41,17.57C977.8,287.91,976.48,287.85,975.17,287.75Z",
    transform: "translate(-45.1 -45.24)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1056.76,261.09a12.43,12.43,0,0,1,6,1.56,11.3,11.3,0,0,1,4.51,4.48,12.19,12.19,0,0,1,0,12.16,11.41,11.41,0,0,1-4.49,4.49,12.17,12.17,0,0,1-12.1,0,11.41,11.41,0,0,1-4.49-4.49,12.19,12.19,0,0,1,0-12.16,11.3,11.3,0,0,1,4.51-4.48A12.43,12.43,0,0,1,1056.76,261.09Zm0,2.38a9.84,9.84,0,0,0-4.81,1.25,9.17,9.17,0,0,0-3.63,3.6,9.83,9.83,0,0,0,0,9.79,9.31,9.31,0,0,0,3.61,3.62,9.73,9.73,0,0,0,9.72,0,9.37,9.37,0,0,0,3.61-3.62,9.77,9.77,0,0,0,0-9.79,9.11,9.11,0,0,0-3.63-3.6A9.89,9.89,0,0,0,1056.78,263.47Zm-5.51,16.27v-12.9h2.62c2.45,0,3.83,0,4.12,0a5.08,5.08,0,0,1,2,.51,3.19,3.19,0,0,1,1.2,1.24,3.65,3.65,0,0,1,.49,1.85,3.42,3.42,0,0,1-.92,2.39,4.17,4.17,0,0,1-2.56,1.23,3.07,3.07,0,0,1,.91.48,6.62,6.62,0,0,1,.87,1c.09.13.41.65,1,1.57l1.52,2.6h-3.23l-1.08-2.09a8.89,8.89,0,0,0-1.81-2.66,2.93,2.93,0,0,0-1.81-.55h-.68v5.3Zm2.62-7.33H1055a12.89,12.89,0,0,0,2.82-.17,1.69,1.69,0,0,0,.86-.61,1.65,1.65,0,0,0,.32-1,1.55,1.55,0,0,0-.31-1,1.78,1.78,0,0,0-.88-.61,12.71,12.71,0,0,0-2.81-.18h-1.06Z",
    transform: "translate(-45.1 -45.24)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 301.93,
    y: 281.46,
    width: 721.88,
    height: 77.93
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(533.01 317.71)"
  }, "A "), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(579.44 317.71)"
  }, "Real", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 95.04,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 123.88,
    y: 0
  }, "age"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 199.78,
    y: 0
  }, "\xAE")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(792.01 317.71)"
  }, /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve"
  }, " Compa"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 160.18,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 186.19,
    y: 0
  }, "y")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ced220a0.svg";
export { ForwardRef as ReactComponent };